<template>
  <div>
    <v-container>
      <v-row v-if="album">
        <v-col cols="12">
          <v-card>
            <v-container fluid pa-0>
              <v-row>
                <v-col cols="4" sm="3" md="2">
                  <v-img :src="album.icon_url || 'https://fakeimg.pl/100x100/?text=preview'"></v-img>
                </v-col>
                <v-col cols="8" sm="9" md="10">
                  <div class="headline">{{album.title}}</div>
                  <div class="body-1">{{album.outline}}</div>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <v-row>
                <v-col>
                  音檔
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-list v-if="album.tracks && album.tracks.length > 0">
                    <template v-for="(track,i) in album.tracks">
                      <v-list-item
                        :key="i"
                        @click="onClickTrack(track, i, 'play')"
                      >
                        <v-list-item-content>
                          <v-list-item-title v-text="track.title"></v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-icon>
                          <v-btn icon @click.stop="onClickTrack(track, i, 'delete')">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </v-list-item-icon>
                      </v-list-item>
                      <v-divider
                        v-if="i + 1 < album.tracks.length"
                        :key="'d-' + i"
                      ></v-divider>
                    </template>
                  </v-list>
                  <v-btn block color="secondary" dark @click="trackDialogOpen">Add new</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- end of main -->
    <v-dialog v-model="trackForm.show" :persistent="trackForm.watting">
      <template v-if="trackForm.show">
        <v-card>
          <v-form ref="form" v-model="trackForm.vaild">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-container fluid pa-0>
                    <v-row justify="center">
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="trackForm.data.title"
                          :counter="40"
                          label="名稱"
                          :rules="[rule.required, input => input.length < 40 || '超出字數限制']"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <template v-if="trackForm.useFile">
                          <v-file-input
                            v-model="trackForm.audioFile"
                            label="上傳音檔"
                            prepend-icon="mdi-cast-audio"
                            :rules="[rule.required]"
                          ></v-file-input>
                        </template>
                        <template v-else>
                          <v-text-field
                            v-model="trackForm.data.audio_url"
                            label="音檔連結"
                            :rules="[rule.required, rule.isUrl]"
                          ></v-text-field>
                        </template>
                        <v-btn @click="trackForm.useFile = !trackForm.useFile">
                          {{trackForm.useFile ? '使用連結' : '上傳檔案'}}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="text-right">
                  <template v-if="!trackForm.watting">
                    <v-btn color="primary" @click="trackDialogSubmit()" :disabled="!trackForm.vaild">建立</v-btn>
                    <v-btn @click="trackDialogClose()">取消</v-btn>
                  </template>
                  <template v-else>
                    <v-btn color="primary" :loading="trackForm.watting">loadding</v-btn>
                  </template>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card>
      </template>
    </v-dialog>
    <audio ref="audio" style="display:none;"></audio>
  </div>
</template>

<script>
import { toDataUrl } from '@/lib/util'
import { getAlbum, postAlbumTrack } from '@/lib/album'
export default {
  data(){
    return {
      album: null,
      trackForm: {
        show: false,
        vaild: false,
        data: null,
        audioFile: null,
        watting: false,
        useFile: true,
        defaultData: {
          title: '',
          audio_url: ''
        }
      },
      rule: {
        required: (r) => !!r || '該欄位為必填',
        isUrl: (url) => {
          try{
            // eslint-disable-next-line no-unused-vars
            let u = new URL(url)
          }catch(e){
            return '該連結內容不正確'
          }
        }
      }
    }
  },
  mounted(){
    getAlbum(this.$route.params.albumId).then((res)=>{
      this.album = res.data
    })
    this.trackDialogReset()
  },
  methods: {
    trackDialogReset(){
      this.trackForm.audioFile = null
      this.trackForm.data = Object.assign({}, this.trackForm.defaultData)
    },
    trackDialogOpen(){
      this.trackDialogReset()
      this.trackForm.show = true
    },
    async trackDialogSubmit(){
      if(!this.trackForm.watting){
        this.trackForm.watting = true
        let data = { ...this.trackForm.data }
        data.aid = this.album.id
        data.track_order = (this.album.tracks || []).length
        try{
          if(this.trackForm.useFile){
            data.audio_url = await toDataUrl(this.trackForm.audioFile)
          }else{
            data.audio_url = this.trackForm.data.audio_url
          }
          let res = await postAlbumTrack(data)
          this.album.tracks = this.album.tracks || []
          this.album.tracks.push(data)
          this.trackForm.watting = false
          this.trackDialogClose()
          console.log(res)
        }catch(e){
          console.error(e)
          this.trackForm.watting = false
        }
      }
    },
    trackDialogClose(){
      if(!this.trackForm.watting){
        this.trackForm.show = false
      }
    },
    onClickTrack(track, i, action = null){
      if(action === 'play'){
        let audio = this.$refs.audio
        audio.pause()
        audio.src = track.audio_url
        audio.currentTime = 0
        audio.play()
      }else{
        console.log(`onClickTrack(${i})`, track, action)
      }
    }
  }
}
</script>

<style>

</style>
